import { render } from "./Faq2.vue?vue&type=template&id=42dd0162"
import script from "./Faq2.vue?vue&type=script&lang=js"
export * from "./Faq2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__